















































































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import moment from "moment";
import { API_BASE_URL, COLOUR_OPTIONS, DATE } from "@/shared/global-values";
import { getDateRangeOfBudgetPeriod } from "@/shared/utils";
import IExpense from "@/types/expense";
import IFilter from "@/types/filter";

export default Vue.extend({
  props: {
    budgetPeriod: String,
  },
  data() {
    return {
      colourOptions: COLOUR_OPTIONS,
      dateOptions: DATE,
    };
  },
  computed: {
    filters(): IFilter {
      return this.$store.getters.getFilters;
    },
    isFiltered(): boolean {
      return this.$store.getters.getIsFiltered;
    },
    dateFromDay: {
      get(): string {
        if (this.filters.dateFrom) {
          return this.filters.dateFrom.getDate().toString();
        }
        return "";
      },
      set(newValue): void {
        const dateFromString: string = `${newValue}-${this.dateFromMonth}-${this.dateFromYear}`;
        const dateFrom: Date = moment(dateFromString, "D-MMMM-YYYY").toDate();
        this.$store.dispatch("setFilters", { dateFrom });
      },
    },
    dateFromMonth: {
      get(): string {
        if (this.filters.dateFrom) {
          return DATE.MONTHS[this.filters.dateFrom.getMonth()];
        }
        return "";
      },
      set(newValue): void {
        const dateFromString: string = `${this.dateFromDay}-${newValue}-${this.dateFromYear}`;
        const dateFrom: Date = moment(dateFromString, "D-MMMM-YYYY").toDate();
        this.$store.dispatch("setFilters", { dateFrom });
      },
    },
    dateFromYear: {
      get(): string {
        if (this.filters.dateFrom) {
          return this.filters.dateFrom.getFullYear().toString();
        }
        return "";
      },
      set(newValue): void {
        const dateFromString: string = `${this.dateFromDay}-${this.dateFromMonth}-${newValue}`;
        const dateFrom: Date = moment(dateFromString, "D-MMMM-YYYY").toDate();
        this.$store.dispatch("setFilters", { dateFrom });
      },
    },
    dateToDay: {
      get(): string {
        if (this.filters.dateTo) {
          return this.filters.dateTo.getDate().toString();
        }
        return "";
      },
      set(newValue): void {
        const dateToString: string = `${newValue}-${this.dateToMonth}-${this.dateToYear}`;
        const dateTo: Date = moment(dateToString, "D-MMMM-YYYY").toDate();
        this.$store.dispatch("setFilters", { dateTo });
      },
    },
    dateToMonth: {
      get(): string {
        if (this.filters.dateTo) {
          return DATE.MONTHS[this.filters.dateTo.getMonth()];
        }
        return "";
      },
      set(newValue): void {
        const dateToString: string = `${this.dateToDay}-${newValue}-${this.dateToYear}`;
        const dateTo: Date = moment(dateToString, "D-MMMM-YYYY").toDate();
        this.$store.dispatch("setFilters", { dateTo });
      },
    },
    dateToYear: {
      get(): string {
        if (this.filters.dateTo) {
          return this.filters.dateTo.getFullYear().toString();
        }
        return "";
      },
      set(newValue): void {
        const dateToString: string = `${this.dateToDay}-${this.dateToMonth}-${newValue}`;
        const dateTo: Date = moment(dateToString, "D-MMMM-YYYY").toDate();
        this.$store.dispatch("setFilters", { dateTo });
      },
    },
  },
  methods: {
    toggleFilter(): void {
      this.$store.dispatch("toggleFilter");
    },
    async clearFilters(): Promise<void> {
      const today: Date = new Date();
      const dateRangeOfBudgetPeriod = getDateRangeOfBudgetPeriod(today, this.budgetPeriod);
      this.$store.dispatch("setFilters", { dateFrom: dateRangeOfBudgetPeriod.dateFrom, dateTo: dateRangeOfBudgetPeriod.dateTo, colours: new Set<string>([]) });
      this.$store.dispatch("setIsFiltered", false);

      await this.filter();
    },
    isSelectedColour(colour: string): boolean {
      return this.filters.colours.has(colour);
    },
    async selectColour(event: Event): Promise<void> {
      const colours: Set<string> = this.filters.colours;

      const span: HTMLSpanElement = event.currentTarget as HTMLSpanElement;
      const colour = span.dataset.colour as string;

      if (colours.has(colour)) {
        colours.delete(colour);
      } else {
        colours.add(colour);
      }

      this.$store.dispatch("setFilters", { colours });
      this.$store.dispatch("setIsFiltered", true);
      await this.filter();
    },
    async selectDate(): Promise<void> {
      this.$store.dispatch("setIsFiltered", true);
      await this.filter();
    },
    async filter(): Promise<void> {
      const params: URLSearchParams = new URLSearchParams();
      params.set("date_from", this.filters.dateFrom!.toISOString());
      params.set("date_to", this.filters.dateTo!.toISOString());

      for (const colour of this.filters.colours) {
        params.append("colours", colour);
      }

      try {
        const token: string = await firebase.auth().currentUser!.getIdToken();
        const response: AxiosResponse = await axios.get(`${API_BASE_URL}/expenses`, { params, withCredentials: true, headers: { Authorization: `Bearer ${token}` } });

        const expenses: IExpense[] = response.data.expenses.reduce((expenses: IExpense[], expense: IExpense) => {
          const colourOption = COLOUR_OPTIONS.find((option) => option.colour === expense.colour);
          expense.colourHex = colourOption!.hex;

          return [...expenses, expense];
        }, []);

        this.$store.dispatch("setExpenses", expenses);

      } catch (error) {
        console.error(error);
      }
    },
  },
});
